export default "__VITE_ASSET__DM4YqEe$__"